import { combineReducers } from 'redux';

import modalReducer from './modal.slice';
import miscReducer from './misc.slice';

export const RootReducer = combineReducers({
    misc: miscReducer,
    modals: modalReducer,
});